import { createStore, createLogger } from 'vuex'
import createPersistedstate from './persistState'
import device from './device'
import scroll from './scroll'
import destination from './destination'
import category from './category'
import location from './location'
import cart from './cart'
import carRental from './carRental'
import history from './history'
import member from './member'

const debug = process.env.NODE_ENV !== 'production';

export default createStore({
  modules: {
    device,
    scroll,
    destination,
    category,
    location,
    cart,
    carRental,
    history,
    member
  },
  plugins: debug
    ? [createPersistedstate()]
    : [/*createLogger(),*/ createPersistedstate()]
})